import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Contact.css';
import { FaPhone, FaEnvelope, FaLinkedin, FaGithub, FaArrowRight } from 'react-icons/fa';

const Contact = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const contactInfo = [
        {
            icon: <FaPhone />,
            label: "Phone",
            value: "+20 109 667 8823",
            link: "tel:+201096678823"
        },
        {
            icon: <FaEnvelope />,
            label: "Email",
            value: "ma7moudsala7elfar@gmail.com",
            link: "mailto:ma7moudsala7elfar@gmail.com"
        },
        {
            icon: <FaLinkedin />,
            label: "LinkedIn",
            value: "Connect with me",
            link: "https://www.linkedin.com/in/ma7moudsala7elfar"
        },
        {
            icon: <FaGithub />,
            label: "GitHub",
            value: "View my code",
            link: "https://github.com/ma7moudsala7elfar"
        }
    ];

    return (
        <section className="contact" id="contact">
            <div className="contact-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container contact-container">
                <div className="contact-content" data-aos="fade-up">
                    <div className="contact-header">
                        <h2 className="contact-title">
                            Let's Work <span className="gradient-text">Together</span>
                        </h2>
                        <p className="contact-subtitle">
                            Have a project in mind? Let's discuss how I can help bring your ideas to life.
                        </p>
                    </div>

                    <div className="contact-cards">
                        {contactInfo.map((info, index) => (
                            <a
                                href={info.link}
                                className="contact-card"
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                                target={info.label === "LinkedIn" ? "_blank" : undefined}
                                rel={info.label === "LinkedIn" ? "noopener noreferrer" : undefined}
                            >
                                <div className="contact-icon">{info.icon}</div>
                                <div className="contact-info">
                                    <span className="contact-label">{info.label}</span>
                                    <span className="contact-value">{info.value}</span>
                                </div>
                                <FaArrowRight className="arrow-icon" />
                            </a>
                        ))}
                    </div>

                    <div className="cta-section" data-aos="fade-up" data-aos-delay="300">
                        <h3 className="cta-title">Ready to start your project?</h3>
                        <p className="cta-description">
                            Whether you need a full-stack web application, AI/ML solution, or e-commerce platform,
                            I'm here to help turn your vision into reality.
                        </p>
                        <div className="cta-buttons">
                            <a href="mailto:ma7moudsala7elfar@gmail.com" className="cta-button primary">
                                <FaEnvelope />
                                Send Email
                            </a>
                            <a
                                href="https://www.linkedin.com/in/ma7moudsala7elfar"
                                className="cta-button secondary"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedin />
                                Connect on LinkedIn
                            </a>
                        </div>
                    </div>
                </div>

                <footer className="footer" data-aos="fade-up" data-aos-delay="400">
                    <div className="footer-content">
                        <p className="footer-text">
                            © {new Date().getFullYear()} Mahmoud Salah Elfar. All rights reserved.
                        </p>
                        <div className="footer-links">
                            <a
                                href="https://github.com/ma7moudsala7elfar"
                                className="footer-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaGithub />
                            </a>
                            <a
                                href="https://www.linkedin.com/in/ma7moudsala7elfar"
                                className="footer-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedin />
                            </a>
                            <a
                                href="mailto:ma7moudsala7elfar@gmail.com"
                                className="footer-link"
                            >
                                <FaEnvelope />
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        </section>
    );
};

export default Contact;
